import momencik from '../../../common/momencik';

const rawEmailResendFromDate = process.env.REACT_APP_EMAIL_RESEND_FROM_DATE;

export const emailResendFromDate: Date | undefined = (() => {
  if (!rawEmailResendFromDate) {
    return undefined;
  }
  const parsed = new Date(rawEmailResendFromDate);
  return isNaN(parsed.getTime()) ? undefined : parsed;
})();

export const canResendEmail = (sendDate?: Date): boolean => {
  if (!emailResendFromDate) {
    return true;
  }
  if (!sendDate) {
    return true;
  }
  return sendDate.getTime() >= emailResendFromDate.getTime();
};

export const emailResendFromDateText = (): string =>
  momencik(emailResendFromDate, 'YYYY-MM-DD');
